export default "__VITE_ASSET__74f9eb64__"